import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { AxiosInstance } from "../../../../axios";
import { R_PER_PAGE } from "../../../../labels";
import Swal from "sweetalert2";
import Loader from "../../Loader";
import { Chip, Paper } from "@mui/material";
import DatePickerSample from "../../DatePicker";
import styles from "./TeachingListview.module.css";
import "./Profile.css";
import "./FacultyDatePicker.module.css";
import moment from "moment";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";

function NFSalaryListView(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { filSearch, filPayment, FilDate } = location.state || {};
  const modalCloseRef = useRef(null);
  // use state
  let page = R_PER_PAGE;
  const moment = require("moment-timezone");
  const [isLoading, setIsLoading] = useState(false);
  // use state
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("asc");
  const [updateListData, setUpdateListData] = useState([]);
  const [csvListData, setCsvListData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [error, setError] = useState([]);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPayment, setSelectedPayment] = useState([]);
  const [appOn, setAppOn] = useState([]);
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [isOpen, setIsOpen] = useState({
    payment_mode: false,
    appliedOn: false,
  });
  const txtBSearch = useRef(null);
  const filterAppliedRef = useRef(null);
  const filterPaymentModeRef = useRef(null);
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);

  const PaymentOption = [
    { id: 0, name: "Others" },
    { id: 1, name: "Month" },
    { id: 2, name: "Per Class" },
  ];

  // ------chipdata listitem------
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  useEffect(() => {
    let chipData = [];

    if (filPayment && filPayment.length > 0) {
      setSelectedPayment(filPayment);
      chipData.push(
        ...filPayment.map((item) => ({
          type: "payment_mode",
          id: item.id,
          name: item.name,
        }))
      );
    }

    if (filSearch && filSearch.length > 0) {
      setSearchTerm(filSearch);
      chipData.push({
        type: "search",
        name: filSearch,
      });
    }

    if (FilDate && FilDate.length > 0) {
      setAppOn(FilDate);
      const { name, fdate, edate, Days } = FilDate[0];
      setAppData({
        FDate: fdate || "",
        TDate: edate || "",
        Days: Days || "",
        name: name || "",
      });
      chipData.push({
        type: FilDate[0].type,
        name,
        fdate,
        edate,
      });
    }

    if (chipData.length > 0) {
      setUpdateChipData(chipData);
      loadListdata();
    }
  }, []);

  //sorting function
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };

  // filter checkbox update
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let role_id = null;
  let user_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      role_id = user.role_id;
      user_type = user.user_type;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  function loadListdata() {
    let statusFilter = {
      staff_id: props.staff_id,
      search: searchTerm.length > 0 ? searchTerm : "",
      start_date: appOn.length > 0 ? appOn[0].fdate : "",
      end_date: appOn.length > 0 ? appOn[0].edate : "",
      payment_mode:
        selectedPayment.length > 0
          ? selectedPayment.map((item) => item.id)
          : "",
    };

    setIsLoading(true);
    AxiosInstance.post("api/staff/salary/list", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          const updatedData = res.data.data.list.map((item) => {
            return item;
          });
          // Filter out null items
          const filteredData = updatedData.filter((item) => item !== null);
          // Set the state with the filtered data
          const serialNumberAddedData = filteredData.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          // setUpdateListData(fiata);
          const csvFormattedData = serialNumberAddedData.map((item) => {
            // Format based on payment_mode
            let paymentPeriod = "-";

            if (item.payment_mode === "Month") {
              paymentPeriod = moment(item.month_of).isValid()
                ? moment(item.month_of).format("YYYY/MM")
                : "-";
            } else if (item.payment_mode === "Per class") {
              const start = moment(item.start_date).isValid()
                ? moment(item.start_date).format("YYYY/MM/DD")
                : "-";
              const end = moment(item.end_date).isValid()
                ? moment(item.end_date).format("YYYY/MM/DD")
                : "-";
              paymentPeriod = `${start} - ${end}`;
            } else if (item.payment_mode === "Others") {
              paymentPeriod = moment(item.start_date).isValid()
                ? moment(item.start_date).format("YYYY/MM")
                : "-";
            }
            return {
              serialNumber: item.serialNumber,
              processed_date: moment(item.processed_date).isValid()
                ? moment(item.processed_date).format("YYYY/MM/DD")
                : "-",
              payment_mode: item.payment_mode ?? "-",
              description: item.description ?? "-",
              no_of_class: item.no_of_class ?? "-",
              payment_period: paymentPeriod,
              tot_salary: item.tot_salary ?? "-",
              deduction: item.deduction ?? "-",
              takehome_salary: item.takehome_salary ?? "-",
            };
          });
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
          setCsvListData(csvData);
          const salary = res.data.data.staff_salary.map((item) => {
            return {
              no_class:
                item.salary_type !== null
                  ? item.salary_type === 0
                    ? "0"
                    : "1"
                  : "0",
              per_class_amount: item.salary,
            };
          });

          setFormData((prevFormData) => ({
            ...prevFormData,
            ...salary[0], // Assuming you want to update the form data with the first item in the 'salary' array
          }));
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setUpdateListData([]);
        return error;
      });
  }

  useEffect(() => {
    loadListdata();
  }, [updateChipData]);

  const [formData, setFormData] = useState({
    no_class: "0",
    per_class_amount: "",
  });
  // generate pdf when user click download button
  const generatePDF = () => {
    const headers = [
      "S.No",
      "Processed On",
      "Payment Mode",
      "Description",
      "Number of Classes",
      "Date Range",
      "Total Salary",
      "Deduction",
      "Take Home Salary",
    ];
    const rows = csvData.map((item, index) => {
      // Format based on payment_mode
      let paymentPeriod = "-";

      if (item.payment_mode === "Month") {
        paymentPeriod = moment(item.month_of).isValid()
          ? moment(item.month_of).format("YYYY/MM")
          : "-";
      } else if (item.payment_mode === "Per class") {
        const start = moment(item.start_date).isValid()
          ? moment(item.start_date).format("YYYY/MM/DD")
          : "-";
        const end = moment(item.end_date).isValid()
          ? moment(item.end_date).format("YYYY/MM/DD")
          : "-";
        paymentPeriod = `${start} - ${end}`;
      } else if (item.payment_mode === "Others") {
        paymentPeriod = moment(item.start_date).isValid()
          ? moment(item.start_date).format("YYYY/MM/DD")
          : "-";
      }

      return [
        index + 1,
        moment(item.processed_date).isValid()
          ? moment(item.processed_date).format("DD/MM/YYYY")
          : "-",
        item.payment_mode ?? "-",
        item.description ?? "-",
        item.no_of_class ?? "-",
        paymentPeriod,
        item.tot_salary ?? "-",
        item.deduction ?? "-",
        item.takehome_salary ?? "-",
      ];
    });

    navigate("/preview", {
      state: {
        title: "Teaching Salary Data",
        headers,
        rows,
        filename: "TeachingSalary.pdf",
        autoPrint: true,
      },
    });
  };
  // total table data  with pages
  const totalPages = Math.ceil(updateListData.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  // page count handle
  const handlePageCount = (e) => {
    const { name, value, checked } = e.target;
    if (name === "pageCount") {
      setRowsPerPage(parseInt(value));
      setCurrentPage(1);
      setUpdateListData([]);
    }
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData.slice(start, end);

  const handleReadView = (id, staff_id) => {
    navigate(
      `/Faculties/ReadViewSalary/${props.userId}/${id}/${staff_id}/${props.staff_type}`,
      {
        state: {
          SEARCH: searchTerm,
          PAYMENT: selectedPayment,
          DATE: appOn,
          ACTIVETAB: props.activeTab,
        },
      }
    );
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError({
      ...error,
      [name]: "",
    });
  };

  const validateSalaryDetails = (data) => {
    const errors = {};

    if (data.no_class === "") {
      errors.no_class = "Please choose class.";
    }
    if (data.per_class_amount === "") {
      errors.per_class_amount = "Please enter amount.";
    }
    return errors;
  };
  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    const errors = validateSalaryDetails(formData);
    if (Object.keys(errors).length === 0) {
      try {
        AxiosInstance.post("api/staff/salary/cost/edit", {
          staff_id: parseInt(props.staff_id),
          staff_type: props.staff_type,
          salary_type: parseInt(formData.no_class),
          salary: parseInt(formData.per_class_amount),
        })
          .then((res) => {
            if (res.data.status === true) {
              Swal.fire({
                title: "Success",
                text: res.data.message,
                icon: "success",
                confirmButtonText: "Ok",
                willClose: () => {
                  const modal = document.querySelector("#myModal"); // Adjust the selector as needed
                  const modal_close = modalCloseRef.current;
                  if (modal && modal_close) {
                    modal_close.click();
                  }
                },
              });
            } else {
              Swal.fire({
                title: "Success",
                text: res.data.message,
                icon: "success",
                confirmButtonText: "Ok",
              });
            }
          })
          .catch((error) => {
            return error;
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(errors);
    }
  };

  const handleFilter = (e, type) => {
    e.stopPropagation();
    setIsOpen((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  const handleCheckboxChange = (e, type) => {
    const { name, value, checked } = e.target;
    setSelectedPayment((prev) => {
      if (checked) {
        return [...prev, { id: parseInt(value), name, type: "payment_mode" }];
      } else {
        return prev.filter((item) => item.name !== name);
      }
    });
  };

  const handleClear = (type) => {
    if (type === "payment_mode") {
      setSelectedPayment([]);
      setIsOpen((prev) => ({ ...prev, payment_mode: false }));

      setUpdateChipData((prev) =>
        prev.filter((item) => item.type !== "payment_mode")
      );
    } else if (type === "appliedOn") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      setUpdateChipData((prev) =>
        prev.filter((item) => item.type !== "appliedOn")
      );
      setIsOpen({
        ...isOpen,
        appliedOn: false,
      });
    }
  };

  const handleApplyFilter = (type) => {
    if (type === "payment_mode") {
      // Remove existing payment_mode chips and add current selected ones
      setUpdateChipData((prev) => [
        ...prev.filter((item) => item.type !== "payment_mode"),
        ...selectedPayment.map((item) => ({
          type: "payment_mode",
          id: item.id,
          name: item.name,
        })),
      ]);
    } else if (type === "appliedOn") {
      setUpdateChipData((prev) => [
        ...prev.filter(
          (item) => item.type !== "dayRange" && item.type !== "dateRange"
        ),
        ...(appOn.length > 0
          ? [
              {
                type: appOn[0].type,
                name: appOn[0].name,
                fdate: appOn[0].fdate,
                edate: appOn[0].edate,
              },
            ]
          : []),
      ]);
    }

    setIsOpen((prev) => ({ ...prev, [type]: false }));
  };

  const handleDelete = (chipToDelete, index) => () => {
    if (chipToDelete.type === "payment_mode") {
      setSelectedPayment(
        selectedPayment.filter((item) => item.id !== chipToDelete.id)
      );
      setUpdateChipData((prev) => {
        return prev.filter(
          (e) => !(e.type === "payment_mode" && e.id === chipToDelete.id)
        );
      });
    } else if (
      chipToDelete.type === "dayRange" ||
      chipToDelete.type === "dateRange"
    ) {
      setAppOn(appOn.filter((item) => item.id !== chipToDelete.id));
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      });
      setUpdateChipData((prev) =>
        prev.filter(
          (e) =>
            !(
              (chipToDelete.type === "dayRange" ||
                chipToDelete.type === "dateRange") &&
              e.fdate === chipToDelete.fdate &&
              e.edate === chipToDelete.edate &&
              e.name === chipToDelete.name
            )
        )
      );
    } else if (chipToDelete.type === "search") {
      setSearchTerm("");
      setUpdateChipData((prev) => {
        const filteredData = prev.filter((e) => e.type !== "search");
        return filteredData;
      });
    }
  };

  const handleAllClear = () => {
    setSearchTerm("");
    setSelectedPayment([]);
    setUpdateChipData([]);
    setAppOn([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
      name: "",
    });
    loadListdata();
  };

  // Handles Search Input and Updates Filter Chips
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      setSearchTerm(val);
      if (val.length > 0) {
        setUpdateChipData((prev) => [
          ...prev,
          { name: String(val), type: "search" },
        ]);
      } else {
        setSearchTerm("");
      }
    }
  };
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      // First, update the date fields and reset Days
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "", // Reset Days when FDate or TDate is set
        };

        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;

        // Only set AppOn if both from and to dates are available
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  const handleAppliedOn = (e) => {
    const { name, value, checked } = e.target;

    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "", // Reset Days when FDate or TDate is changed
        };

        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        } else {
          setAppOn([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        // Set Days and reset FDate/TDate
        setAppData({
          FDate: "",
          TDate: "",
          Days: value,
        });

        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";

        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }

        setAppOn([
          {
            name: label,
            fdate,
            edate,
            type: "dayRange",
            Days: value,
          },
        ]);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;

      if (
        filterPaymentModeRef.current &&
        !filterPaymentModeRef.current.contains(event.target)
      ) {
        const hasPaymentMode = updateChipData.some(
          (chipItem) => chipItem.type === "payment_mode"
        );

        if (hasPaymentMode) {
          const updatedPaymentMode = updateChipData.filter(
            (chipItem) => chipItem.type === "payment_mode"
          );

          setSelectedPayment(updatedPaymentMode);
        } else {
          setSelectedPayment([]);
        }
        setIsOpen((prev) => ({ ...prev, payment_mode: false }));
      }
      if (
        filterAppliedRef.current &&
        !filterAppliedRef.current.contains(event.target)
      ) {
        const mismatchedDay = updateChipData.find(
          (chipItem) => chipItem.Days && chipItem.Days === appData.Days
        );

        if (mismatchedDay) {
          setAppData({
            FDate: "",
            TDate: "",
            Days: mismatchedDay.Days,
          });
          setAppOn([
            {
              FDate: "",
              TDate: "",
              Days: mismatchedDay.Days,
            },
          ]);
        } else {
          const mismatchedDate = updateChipData.find(
            (chipItem) =>
              chipItem.fdate === appData.FDate &&
              chipItem.edate === appData.TDate
          );

          if (mismatchedDate) {
            setAppData({
              FDate: mismatchedDate.fdate,
              TDate: mismatchedDate.edate,
              Days: "",
            });
            setAppOn([
              {
                FDate: mismatchedDate.fdate,
                TDate: mismatchedDate.edate,
                Days: "",
              },
            ]);
          } else {
            setAppData({
              FDate: "",
              TDate: "",
              Days: "",
            });
            setAppOn([]);
          }
        }

        setIsOpen((prev) => ({ ...prev, appliedOn: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Processed Date", key: "processed_date" },
    { label: "Payment Mode", key: "payment_mode" },
    { label: "Description", key: "description" },
    { label: "Number of Classes", key: "no_of_class" },
    { label: "Date Range", key: "payment_period" },
    { label: "Total Salary", key: "tot_salary" },
    { label: "Deduction", key: "deduction" },
    { label: "Take Home Salary", key: "takehome_salary" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div
        className={`${styles.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid  global_container p-0`}
      >
        {/* ---------------------------------------------------------------- */}
        <div className="row ">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div class="input-group ">
              <input
                ref={txtBSearch}
                type="text"
                class={styles.Inputs}
                id="SearchInput"
                name="SearchInput"
                placeholder="Search by description"
                onKeyDown={handleSearch}
              />
              <span
                class={styles.input_group_text}
                id="SearchInput"
                onClick={handleSearchFocus}
              >
                <span className="material-icons" onClick={handleSearchFocus}>
                  search
                </span>
              </span>
            </div>
          </div>

          <div className="col-md-8 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <CustomDownloadButton
                  csvListData={csvData?.length > 0 ? csvData : ""}
                  headers={csvHeaders}
                  iconName=" file_download "
                  filename={"TeachingSalary.csv"}
                  csvName="Download as CSV"
                />
              </li>
              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  className="primaryButton "
                  variant="primary"
                  onClick={generatePDF}
                >
                  <span className="material-icons me-2 fs-4 align-middle text-white">
                    file_download
                  </span>
                  <span className="text-white">Download as PDF</span>
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  to={`/Faculties/AddSalary/${props.userId}/${props.staff_id}/${props.staff_type}/0`}
                  className="primaryButton "
                  variant="primary"
                >
                  Add New Salary
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {updateChipData?.filter((kl) => kl.name !== "ActiveTab").length > 0 ? (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 paperil_global ">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData
                  ?.filter((kl) => kl.name !== "ActiveTab")
                  ?.map((data, index) => {
                    let icon;
                    let key = "" + data.name;
                    return (
                      <ListItem key={data}>
                        <Chip
                          icon={icon}
                          label={key}
                          onDelete={handleDelete(data, index)}
                        />
                      </ListItem>
                    );
                  })}

                <ListItem className="clearAll_list">
                  <a className="clearAll_listItem" onClick={handleAllClear}>
                    Clear All Filters
                  </a>
                </ListItem>
              </Paper>
            </div>
          </div>
        ) : (
          <div></div>
        )}

        <div className="row mt-2">
          <div className="col-md-12 table-responsive tableMinHeight ">
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  {/* S.No. */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      S.No
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  {/*  Processed On */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "processed_date")}
                    >
                      {" "}
                      Processed On
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "processed_date")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      onClick={(e) => handleFilter(e, "appliedOn")}
                      class={` align-middle material-icons ${
                        (appData &&
                          Object.entries(appData).some(
                            ([key, val]) =>
                              key !== "name" &&
                              val !== null &&
                              val !== undefined &&
                              val.toString().trim() !== ""
                          )) ||
                        isOpen.appliedOn
                          ? "active_icons"
                          : ""
                      }`}
                    >
                      filter_list
                    </span>
                    {isOpen.appliedOn === true && (
                      <div
                        className="filterBoxOne filter_mmm container p-1"
                        ref={filterAppliedRef}
                        style={{ width: "240px", height: "332px" }}
                      >
                        <div
                          className=" BathDet "
                          style={{ padding: 0, marginTop: 0, marginBottom: 0 }}
                        >
                          <div className="row mt-1">
                            <div className="col-md-12">
                              <div class="form-check p-1">
                                <label
                                  htmlFor="FDate"
                                  className="d-flex form-label"
                                  style={{
                                    textAlign: "left",
                                    fontSize: "var(--fontSizeFourteen)",
                                    fontWeight: "var(--boldtextWeight)",
                                    fontFamily: "var(--fontfamily2)",
                                    letterSpacing: "0.28px",
                                    color: "var(--colorBlue)",
                                    opacity: 1,
                                  }}
                                >
                                  From Date
                                  <span
                                    data-required="true"
                                    aria-hidden="true"
                                  ></span>
                                </label>

                                <DatePickerSample
                                  IconInput={"filterIocnBoxInput"}
                                  class={"FilterInputs"}
                                  name={"FDate"}
                                  handleChange={handleChangeDate}
                                  fieldInput={appData.FDate}
                                  txtAdMDob={fDatePickerRef}
                                  // maxDate={new Date()}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row mt-1">
                            <div className="col-md-12">
                              <div class="form-check p-1">
                                <label
                                  htmlFor="TDate "
                                  className="d-flex form-label"
                                  style={{
                                    textAlign: "left",
                                    fontSize: "var(--fontSizeFourteen)",
                                    fontWeight: "var(--boldtextWeight)",
                                    fontFamily: "var(--fontfamily2)",
                                    letterSpacing: "0.28px",
                                    color: "var(--colorBlue)",
                                    opacity: 1,
                                  }}
                                >
                                  To Date
                                  <span
                                    data-required="true"
                                    aria-hidden="true"
                                  ></span>
                                </label>
                                <DatePickerSample
                                  class={"FilterInputs"}
                                  IconInput={"filterIocnBoxInput"}
                                  name={"TDate"}
                                  handleChange={handleChangeDate}
                                  fieldInput={appData.TDate}
                                  txtAdMDob={tDatePickerRef}
                                  minDate={appData.FDate}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2 mb-2">
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                id="Today"
                                value="Today"
                                checked={appData.Days === "Today"}
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Today"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Today
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                id="Yesterday"
                                value="Yesterday"
                                checked={appData.Days === "Yesterday"}
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Yesterday"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Yesterday
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                value="Tweek"
                                checked={appData.Days === "Tweek"}
                                id="Tweek"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Tweek"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                This week
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                value="Lweek"
                                checked={appData.Days === "Lweek"}
                                id="Lweek"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Lweek"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Last week
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                value="Tmonth"
                                checked={appData.Days === "Tmonth"}
                                id="Tmonth"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Tmonth"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                This month
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                checked={appData.Days === "Lmonth"}
                                value="Lmonth"
                                id="Lmonth"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Lmonth"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Last month
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                onClick={() => handleClear("appliedOn")}
                                className="secondaryButton ms-2"
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                onClick={() => handleApplyFilter("appliedOn")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>
                  {/* Payment Mode */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "payment_mode")}
                    >
                      Payment Mode
                    </span>

                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "payment_mode")}
                    >
                      import_export
                    </span>

                    <span
                      className={`textHead_th align-middle material-icons ${
                        selectedPayment.length > 0 || isOpen.payment_mode
                          ? styles.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "payment_mode")}
                    >
                      filter_list
                    </span>

                    {isOpen.payment_mode && (
                      <div
                        className="filterBoxs_testlist"
                        style={{ top: "35px" }}
                        ref={filterPaymentModeRef}
                      >
                        <div className="col-md-12 form-check filterStatus_list"></div>

                        <ul className="ulFilterListData">
                          {PaymentOption.map((el) => (
                            <li className="filterListData" key={el.id}>
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={el.name}
                                value={el.id}
                                id={el.name}
                                checked={selectedPayment.some(
                                  (item) => item.id === el.id
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "payment_mode")
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor={el.name}
                              >
                                {el.name}
                              </label>
                            </li>
                          ))}
                        </ul>

                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                onClick={() => handleClear("payment_mode")}
                                className="secondaryButton ms-2"
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                onClick={() =>
                                  handleApplyFilter("payment_mode")
                                }
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>

                  {/* Description */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "description")}
                    >
                      {" "}
                      Description
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "description")}
                    >
                      import_export
                    </span>{" "}
                  </th>
                  {/* Number of Classes */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "no_of_class")}
                    >
                      {" "}
                      Number of Classes
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "no_of_class")}
                    >
                      import_export
                    </span>{" "}
                  </th>

                  {/*  Date Range */}
                  <th id="th">
                    <span
                      className="textHead_th px-1"
                      // onClick={(e) => handleSort(e, "start_date")}
                    >
                      Date Range
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      // onClick={(e) => handleSort(e, "start_date")}
                    >
                      import_export
                    </span>
                  </th>

                  {/*  Total Salary */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "tot_salary")}
                    >
                      {" "}
                      Total Salary
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "tot_salary")}
                    >
                      import_export
                    </span>{" "}
                  </th>

                  {/* Deduction */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "deduction")}
                    >
                      {" "}
                      Deduction
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "deduction")}
                    >
                      import_export
                    </span>{" "}
                  </th>

                  {/* Take Home Salary */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "takehome_salary")}
                    >
                      {" "}
                      Take Home Salary
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "takehome_salary")}
                    >
                      import_export
                    </span>{" "}
                  </th>

                  <th id="th">
                    <span className="textHead_th">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData?.map((course, index) => (
                    <tr key={index} title={index}>
                      <td id="td">{course.serialNumber}</td>
                      <td id="td">
                        {" "}
                        {moment(course.processed_date).format("YYYY-MM-DD")}
                      </td>
                      <td id="td"> {course.payment_mode}</td>
                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={styles.ellipsis}
                          title={course.description}
                        >
                          {course.description ? course.description : "-"}
                        </span>
                      </td>
                      <td id="td">
                        {" "}
                        {course.no_of_class ? course.no_of_class : "-"}
                      </td>
                      <td id="td">
                        {course.month_of === null ? (
                          <>
                            {moment(course.start_date).format("YYYY-MM-DD")}
                            {course.end_date !== null && (
                              <>
                                {" - "}
                                {moment(course.end_date).format("YYYY-MM-DD")}
                              </>
                            )}
                          </>
                        ) : (
                          course.month_of
                        )}
                      </td>
                      <td id="td">{course.tot_salary}</td>
                      <td id="td">{course.deduction}</td>
                      <td id="td">{course.takehome_salary}</td>
                      <td id="td">
                        <button
                          className={"view_icon_button"}
                          onClick={() =>
                            handleReadView(course.id, course.staff_id)
                          }
                        >
                          <span class="material-icons">visibility</span>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="CourseInfoSec row mt-3">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              updateListData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              updateListData?.length > 0
                ? updateListData?.length < currentPage * rowsPerPage
                  ? updateListData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={updateListData?.length || 0}
            handlePrev={() => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1 || totalPages === 0}
            prevButton="prev_buttonViewEvaluator materialIconsRightAndLeft me-2"
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages || totalPages === 0}
          />
        </div>
      </div>
    </>
  );
}

export default NFSalaryListView;
